import { FormEvent, KeyboardEvent, useState } from 'react';
import logo from '../HomePage/logo-modified.png';
import './styles.css';

const PHONE_NUMBER = '263775967763';

export const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const openWhatsApp = () => {
    const text = message.trim() || "Hello Ruesevents Designs! I'd like to enquire about an event.";
    const url = `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    openWhatsApp();
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      openWhatsApp();
    }
  };

  return (
    <div className="rue-whatsapp-widget">
      {isOpen && (
        <section className="rue-whatsapp-panel" aria-label="Chat with Ruesevents on WhatsApp">
          <header className="rue-whatsapp-header">
            <img src={logo} alt="Ruesevents Designs" />
            <div>
              <strong>Ruesevents Designs</strong>
              <span>Typically replies on WhatsApp</span>
            </div>
            <button
              type="button"
              className="rue-whatsapp-close"
              aria-label="Close WhatsApp chat"
              onClick={() => setIsOpen(false)}
            >
              ×
            </button>
          </header>

          <div className="rue-whatsapp-body">
            <div className="rue-whatsapp-bubble">
              Hello there! 🤝 How can we help?
            </div>
          </div>

          <form className="rue-whatsapp-form" onSubmit={handleSubmit}>
            <label htmlFor="rue-whatsapp-message" className="rue-visually-hidden">
              Type a WhatsApp message
            </label>
            <textarea
              id="rue-whatsapp-message"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Type a message..."
              rows={2}
              autoFocus
            />
            <button type="submit" aria-label="Send message on WhatsApp">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M2.4 3.1 22 11.4c.8.3.8 1.4 0 1.7L2.4 20.9c-.7.3-1.4-.4-1.1-1.1l2.1-5.4 9.3-2.3-9.3-2.5-2.1-5.4c-.3-.7.4-1.4 1.1-1.1Z" />
              </svg>
            </button>
          </form>
        </section>
      )}

      <button
        type="button"
        className="rue-whatsapp-launcher"
        aria-label={isOpen ? 'Close WhatsApp chat' : 'Chat with us on WhatsApp'}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((current) => !current)}
      >
        <svg viewBox="0 0 32 32" aria-hidden="true">
          <path d="M16.1 4.2a11.6 11.6 0 0 0-9.9 17.7L4.4 27.8l6-1.8a11.7 11.7 0 1 0 5.7-21.8Zm0 21.2c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.5 1 1.1-3.4-.2-.4a9.5 9.5 0 1 1 8 4.4Zm5.2-7.1c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.2l-.9 1.1c-.2.3-.4.3-.7.1-1.8-.9-3-2-4.2-3.8-.3-.5.3-.5.9-1.7.1-.3.1-.5 0-.7l-.9-2.1c-.2-.5-.5-.4-.7-.4h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9s1.2 3.3 1.4 3.6c.2.2 2.5 3.8 6.1 5.3.9.4 1.5.6 2 .7.9.3 1.7.2 2.3.1.7-.1 2-.8 2.3-1.6.3-.8.3-1.5.2-1.6-.1-.2-.3-.3-.6-.4Z" />
        </svg>
      </button>
    </div>
  );
};
